import { LoginForm } from 'mk2/apps/users/components/LoginForm';
import { SignupLoginWrapper } from 'mk2/apps/users/components/SignupLoginWrapper';
import { Props } from 'mk2/apps/users/containers/Login/LoginPage';
import React from 'react';
import styles from './Login.mscss';

export default class Login extends React.Component<Props> {

    public render() {
        const { location, onLogin, initialValues, mobile, currentFormPage } = this.props;

        return (
            <SignupLoginWrapper className={styles.Login} qs={location.search} mobile={mobile} currentFormPage={currentFormPage}>
                <LoginForm onLogin={onLogin} initialValues={initialValues}/>
            </SignupLoginWrapper>
        );
    }
}
